export default "__VITE_ASSET__BWlTH5Cf__"